// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zy7p","colBig":"styles_colBig___pg55","colSmall":"styles_colSmall__1--l3"};